import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import axios from 'axios';
import envConfig from '../../../envConfig';

class OrderAndQuoteSearchPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      orderQuoteId: '',
      contactName: '',
      error: false,
      finding: false,
    };
    this.submitSearch.bind(this.submitSearch);
  }

  submitSearch() {
    const { history } = this.props;
    const { orderQuoteId, contactName } = this.state;
    this.setState({ error: false, finding: true });
    return axios.get(`${envConfig.apiUrl}/api/v1/orders-and-quotes/public/search?id=${orderQuoteId}&contact=${contactName}`)
      .then((r) => {
        if (!r.data || !r.data.success) {
          this.setState({ error: true });
        } else {
          const responseId = r.data.data.resourceUri;
          const resourceUrl = responseId.toLowerCase().includes('ord')
            ? `/p/order/${responseId}`
            : `/p/quote/${responseId}`;
          history.push(`${resourceUrl}`);
        }
      })
      .catch(() => {
        this.setState({ error: true });
      }).finally(() => {
        this.setState({ finding: false });
      });
  }

  render() {
    const { error, finding } = this.state;
    return (
      <div className="col-8 mx-auto mt-5">
        <div className="row justify-content-center mb-4">
          <h3 className="text-center">Quote and Order Lookup</h3>
        </div>
        {error && (
          <div className="form-group row">
            <div className="offset-md-3 col">
              <div className="alert alert-danger">
                Record not found.
              </div>
            </div>
          </div>
        )}
        <div className="form-group row">
          {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
          <label htmlFor="orderQuoteNumber" className="col-md-3 col-form-label  text-md-right">Quote/Order Number</label>
          <div className="col-md-9">
            <input
              type="text"
              className="form-control"
              id="orderQuoteId"
              placeholder="ORD-12345"
              onChange={(e) => this.setState({ orderQuoteId: e.target.value })}
            />
            <small className="pl-2 text-muted">Quote and orders numbers begin with QUO- and ORD- respectively.</small>
          </div>
        </div>
        <div className="form-group row">
          {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
          <label htmlFor="contactName" className="col-md-3 col-form-label text-md-right">Contact Name</label>
          <div className="col-md-9">
            <input
              type="text"
              className="form-control"
              id="contactName"
              placeholder="John Doe"
              onChange={(e) => this.setState({ contactName: e.target.value })}
            />
            <small className="pl-2 text-muted">The full contact name that appears on your quote or order.</small>
          </div>
        </div>
        <div className="form-group row">
          <div className="offset-md-3 col">
            <button
              type="button"
              className="btn btn-primary px-4"
              onClick={() => this.submitSearch()}
              disabled={finding}
            >
              {finding ? 'Finding...' : 'Find'}
            </button>
          </div>
        </div>
      </div>
    );
  }
}

OrderAndQuoteSearchPage.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

export { OrderAndQuoteSearchPage };

export default withRouter(OrderAndQuoteSearchPage);
